/** Matrículas con acceso al módulo Agente IA (piloto). */
export const MATRICULAS_AGENTE_IA = ['2021-05427']

export function puedeVerAgenteIA (usuario) {
  const matricula = String((usuario && usuario.usuario) || '').trim()
  return MATRICULAS_AGENTE_IA.includes(matricula)
}
